package com.loyola.acessoescola.ui.addnew

enum class Bounds(val string: String) {
    NONE(""),
    PARENTS("Mãe / Pai"),
    RELATIVE("Parente"),
    EMPLOYEE("Funcionário(a)"),
    DRIVER("Motorista / Escolar"),
    OTHER("Outros")
}